<template>
    <div>
        <div v-if="numberAppliedApplications === 1" class="bg-gray-400 mt-3 mx-2 p-4">
            <div class="inline-block w-full text-center">
                <p class="mb-2">{{$t('component.applicationHint.second_application')}}</p>
                <ApplyButton/>
            </div>
        </div>
        <div v-if="numberAppliedApplications === 1" class="bg-gray-400 mt-3 mx-2 p-4">
            <div class="inline-block w-full text-center">
                <p class="mb-2">{{$t('component.applicationHint.third_application')}}</p>
                <ApplyButton/>
            </div>
        </div>
        <div v-if="numberAppliedApplications === 2" class="bg-gray-400 mt-3 mx-2 p-4">
            <div class="inline-block w-full text-center">
                <p class="mb-2">{{$t('component.applicationHint.third_application')}}</p>
                <ApplyButton/>
            </div>
        </div>
    </div>
</template>
<script>
    import ApplyButton from "@/components/shared/ApplyButton";

    export default {
        name: 'ApplicationHnt',
        components: {
            ApplyButton
        },
        props: {
            numberAppliedApplications: Number,
        }
    }
</script>